import { ArrowDown, MessageCircle, ChevronRight } from "lucide-react";
import { WHATSAPP_URL } from "../../i18n/translations";

export const Hero = ({ t }) => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1759169955734-14def2cb7dd2"
          alt="T-CARS Garage workshop"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 hero-vignette" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 min-h-screen flex flex-col justify-end pb-20 md:pb-28 pt-32">
        <div className="reveal">
          <span className="overline">{t.hero.overline}</span>
        </div>

        <h1
          data-testid="hero-title"
          className="reveal font-heading mt-6 text-5xl sm:text-7xl lg:text-[9rem] leading-[0.85] font-black uppercase text-zinc-50 tracking-tighter"
          style={{ animationDelay: "0.1s" }}
        >
          {t.hero.title_1}
          <span className="text-red-600">.</span>
          <br />
          {t.hero.title_2}
          <span className="text-red-600">.</span>
          <br />
          {t.hero.title_3}
          <span className="text-red-600">.</span>
        </h1>

        <div
          className="reveal mt-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-end"
          style={{ animationDelay: "0.25s" }}
        >
          <p className="md:col-span-6 lg:col-span-5 font-body text-base md:text-lg text-zinc-300 leading-relaxed max-w-xl">
            {t.hero.subtitle}
          </p>

          <div className="md:col-span-6 lg:col-span-7 flex flex-col sm:flex-row gap-3 md:justify-end">
            <a
              data-testid="hero-whatsapp-cta"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-500 text-zinc-950 font-body font-bold text-sm tracking-wider uppercase px-7 py-4 transition-colors"
            >
              <MessageCircle className="w-4 h-4" strokeWidth={2.6} />
              {t.hero.cta_primary}
            </a>
            <button
              data-testid="hero-services-cta"
              onClick={() =>
                document
                  .getElementById("services")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="inline-flex items-center justify-center gap-2 border border-zinc-700 hover:border-zinc-50 text-zinc-50 font-body font-bold text-sm tracking-wider uppercase px-7 py-4 transition-colors"
            >
              {t.hero.cta_secondary}
              <ChevronRight className="w-4 h-4" strokeWidth={2.4} />
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-6 md:left-12 z-10 hidden md:flex items-center gap-3 text-zinc-500">
        <ArrowDown className="w-4 h-4 animate-bounce" strokeWidth={2} />
        <span className="font-body text-[10px] font-bold tracking-[0.3em] uppercase">
          {t.hero.scroll}
        </span>
      </div>

      {/* Vertical info strip */}
      <div className="absolute right-6 top-1/2 -translate-y-1/2 hidden xl:flex flex-col gap-6 z-10 text-zinc-500">
        <span className="rotate-90 origin-center font-body text-[10px] font-bold tracking-[0.4em] uppercase whitespace-nowrap">
          Parets del Vallès — Barcelona
        </span>
      </div>
    </section>
  );
};
